import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  BannerBackButtonSettings,
  BannerButtonSettings,
  BannerChipSettings,
  BannerType,
} from 'lib/Banner/Banner.types';

export interface BannerState {
  type: BannerType;
  headerInfo?: string;
  contentInfo?: string;
  discardButton?: BannerButtonSettings;
  confirmButton?: BannerButtonSettings;
  backButton?: BannerBackButtonSettings;
  exitButton?: BannerButtonSettings;
  chip?: BannerChipSettings;
}

export const initialState: BannerState = {
  type: BannerType.NONE,
  headerInfo: '',
  contentInfo: '',
  backButton: {},
  confirmButton: {},
  discardButton: {},
  exitButton: {},
};

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    showBanner: (_state, action: PayloadAction<BannerState>) => {
      return {
        type: action.payload.type,
        backButton: action.payload.backButton,
        confirmButton: action.payload.confirmButton,
        discardButton: action.payload.discardButton,
        exitButton: action.payload.exitButton,
        headerInfo: action.payload.headerInfo,
        contentInfo: action.payload.contentInfo,
        chip: action.payload.chip,
      };
    },
    hideBanner: () => {
      return {
        ...initialState,
      };
    },
  },
});

export const { showBanner, hideBanner } = bannerSlice.actions;
export default bannerSlice.reducer;
